import { AnyTask, CheckoutOrder } from "tm-shared/types";

import { WorkState } from "./work.slice.types";

export const setTask = (state: WorkState, task: AnyTask) => {
    const { id: taskId, targetId: pointId } = task;
    const targetTasks = (state.tasks[pointId] ??= {});

    targetTasks[taskId] = task;
    state.taskPointMap[taskId] = pointId;
};

export const createCheckoutOrder = (
    order: CheckoutOrder,
    closed: boolean,
): CheckoutOrder => {
    const checkout: CheckoutOrder = {
        ...order,
        products: {},
        closed,
    };

    Object.values(order.products).forEach((product) => {
        checkout.products[product.barcode] = {
            ...product,
            apiCount: product.count,
        };
    });

    return checkout;
};
